import React from 'react';
import logo from '../../assets/logo.svg';
import './SplashScreen.css';

function SplashScreen({ hiding }) {
  return (
    <div className={`splash-root${hiding ? ' splash-root--hide' : ''}`}>
      <div className="splash-logo-wrapper">
        <img src={logo} alt="KCGU logo" className="splash-logo" />
      </div>
    </div>
  );
}

export default SplashScreen;


